import { render, staticRenderFns } from "./invoice-editor.vue?vue&type=template&id=37c0a7af"
import script from "./invoice-editor.vue?vue&type=script&lang=js"
export * from "./invoice-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports